<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoOn_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.533 9.333H19.2a3.333 3.333 0 0 1 3.333 3.334v6.666a3.333 3.333 0 0 1-3.333 3.334H7.533A3.333 3.333 0 0 1 4.2 19.333v-6.666a3.333 3.333 0 0 1 3.333-3.334ZM24.2 13.5l3.633-3.028a.834.834 0 0 1 1.367.64v9.776a.833.833 0 0 1-1.367.64L24.2 18.5v-5Z"
        clip-rule="evenodd"
    />
</svg>
